import { Resume } from './resume';
import { WorkbenchEan } from './workbench-ean';

export class ResumeDto extends Resume {
  products: WorkbenchEan[];
}
